jQuery(function ($) {
  var s
  window.Site = {
    settings: {
      b: $("body"),
      w: $(window),
      d: $(document),
    },

    init: function () {
      s = this.settings

      this.faq()
    },

    setCartClosePosition: function () {
      if ($("#cartTotal").length) {
        var $cartBtnClose = $(".cart-drawer .js-cartToggle"),
          scrollTop = $(window).scrollTop(),
          cartBtnPositionTop = $("#cartTotal").offset().top - scrollTop,
          containerPadding = 40,
          cartBtnTop = cartBtnPositionTop - containerPadding

        $cartBtnClose.css("top", cartBtnTop)
      }
    },

    faq: function () {
      $(".faq-list__item-question").on("click", function (e) {
        e.preventDefault()
        $(this).parent().toggleClass("is-expanded")
      })
    },
  }

  Site.init()
  Cart.init()
})

Cart = {
  popoverTimer: 0,
  init: function () {
    var $cart = $("#Cart"),
      $body = $("body"),
      $popover = $("#CartPopoverCont"),
      enableAjaxCart = window.theme.settings.enableAjaxCart

    this.counter()
    this.initTermsAcceptance()

    // $(window).on("resize", Reqs.throttle(Site.setCartClosePosition, 10))

    /* Continue Shopping link - hide cart overlay if on desktop */
    $cart.on("click", ".js-continueShopping", function (e) {
      e.preventDefault()
      var referrer = document.referrer
      var origin = window.location.origin + "/"
      var isMobile = $(window).width() < 768

      if (!isMobile && !(window.location.href.indexOf("/cart") > -1)) {
        $(".js-cartToggle-close").eq(0).trigger("click")
      } else {
        if (referrer === origin) {
          window.location.href = window.theme.routes.root_url
        } else {
          history.back(1)
        }
      }
    })

    // Don't init cart functions if ajax cart disabled
    if (!enableAjaxCart) return false

    $(document).off("click", ".js-cartToggle")
    $(document).on("click", ".js-cartToggle", function (e) {
      var $this = $(this),
        isCartTemplate = $("body").hasClass("template-cart"),
        windowWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth,
        $scrollableElement = document.querySelector(".scroll")

      if (isCartTemplate) return false

      if (windowWidth > 768) {
        e.preventDefault()

        Site.setCartClosePosition()

        $body.toggleClass("cart--is-visible")
        if ($body.hasClass("cart--is-visible")) {
          $cart.removeClass("close")
          $cart.addClass("open")
          $("#cartTotal").attr("aria-expanded", true)
          scrollLock.disablePageScroll($scrollableElement)
        } else {
          $cart.removeClass("open")
          $cart.addClass("close")
          $("#cartTotal").attr("aria-expanded", false)
          Cart.popover.hide($popover)
          scrollLock.enablePageScroll($scrollableElement)
        }
        $(".js-continueShopping").attr("tabindex", "0")
      } else {
        if ($this.hasClass("js-cartToggle-close")) {
          e.preventDefault()
          $("html").css("overflow", "initial")
          $body.removeClass("cart--is-visible")
          $cart.removeClass("open")
          $cart.addClass("close")
          $("#cartTotal").attr("aria-expanded", false)
          Cart.popover.hide($popover)
        }
        $(".js-continueShopping").attr("tabindex", "-1")
      }
    })

    $("body").on("click", "[data-add-to-cart]", function (e) {
      var $form = $(this).closest("form.productForm")

      if (enableAjaxCart) {
        e.preventDefault()

        if ($form.find('[type="file"]').length) return

        Cart.submit($(this))
      }
    })

    $(window).on("keyup", function (e) {
      if (e.key === "Escape") {
        $body.removeClass("cart--is-visible")
        $cart.removeClass("open")
        $cart.addClass("close")
        $scrollableElement = document.querySelector(".scroll")
        $("#cartTotal").attr("aria-expanded", false)
        Cart.popover.hide($popover)
        scrollLock.enablePageScroll($scrollableElement)
      }
    })
  },
  submit: function (el) {
    var instance = this,
      $form = el.closest("form.productForm"),
      product_handle = el.attr("data-handle"),
      variant_id = $form.find('[name="id"]').val(),
      form_array = $form.serializeArray(),
      addToCart = el,
      addToCartText = el.find("[data-add-to-cart-text]")

    var form_data = {}
    $.map(form_array, function (val, i) {
      form_data[val.name] = val.value
    })

    $.ajax({
      method: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: form_data,
      success: function (product) {
        addToCart.attr("disabled", true)
        addToCartText.html(window.theme.icons.check)

        setTimeout(function () {
          addToCart.attr("disabled", false)
          addToCartText.html(window.theme.translations.form_submit)
        }, 2000)

        Cart.getCart(Cart.buildCart)

        if ($(window).width() >= 550) {
          Cart.popover.show(product)
        }
      },
      // If there are no products in the inventory
      error: function (data) {
        $.ajax({
          method: "GET",
          url: "/products/" + product_handle + ".js",
          dataType: "json",
          success: function (product) {
            var variants = product.variants,
              // variants is an array [0{},1{},2{}...]
              variant = $.each(variants, function (i, val) {
                // val returns the contents of 0,1,2
                if (val.id == variant_id) {
                  return (variant_quantity = val.inventory_quantity) // set variant_quantity variable
                }
              }),
              $popover = $("#CartPopoverCont"), // same popover container used to show succesful cart/add.js
              error_details =
                window.theme.translations.form_submit_error_details, // translation string
              tag = new RegExp("[[i]]"), // checks for [[i]]
              error = error_details // set error to just default to error_details

            if (tag.test(error_details) == true) {
              // [[i]] is part of the trans string, this can be whatever,
              // but in the tutorial we use [[i]] so leave it
              error = error_details.replace("[[i]]", variant_quantity) // re-set error with new string
            }

            addToCartText.html(window.theme.translations.form_submit_error) // swap button text
            setTimeout(function () {
              addToCartText.html(window.theme.translations.form_submit) // swap it back
            }, 1000)

            // clear popover timer, set at top of Cart object
            clearTimeout(instance.popoverTimer)

            // empty popover, add error (with inventory), show it, remove click events so it doesn't open cart
            $popover
              .empty()
              .append('<div class="popover-error">' + error + "</div>")
              .addClass("is-visible")
              .css({ "pointer-events": "none" })

            // set new instance of popoverTimer
            instance.popoverTimer = setTimeout(function () {
              $popover
                .removeClass("is-visible")
                .css({ "pointer-events": "auto" })
            }, 5000)
          },
          error: function () {
            console.log(
              "Error: product is out of stock. If you're seeing this, Cart.submit.error() must have failed."
            )
          },
        })
      },
    })
  },
  popover: {
    show: function (product) {
      var instance = this,
        $popover = $("#CartPopoverCont"),
        item = {},
        source = $("#CartPopover").text(),
        productTitle = this.getTruncatedTitle(product.product_title),
        price = slate.Currency.formatMoney(
          product.final_price,
          window.moneyFormat
        ),
        unitPrice = ""

      // Unit price
      if (product.unit_price_measurement) {
        unitPrice =
          slate.Currency.formatMoney(product.unit_price, window.moneyFormat) +
          " "
        if (product.unit_price_measurement.reference_value != 1) {
          unitPrice += product.unit_price_measurement.reference_value
        }
        unitPrice += product.unit_price_measurement.reference_unit
      }

      // Product image
      if (product.image != null) {
        var prodImg = product.image
          .replace(/(\.[^.]*)$/, "_150x$1")
          .replace("http:", "")
      } else {
        var prodImg =
          "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif"
      }

      item = {
        item_count: product.quantity,
        img: prodImg,
        product_title: productTitle,
        variation:
          product.variant_title == "Default Title"
            ? false
            : product.variant_title,
        price: product.price,
        price_formatted: price,
        unit_price: unitPrice,
      }

      var template = Sqrl.render(source, item)

      $popover.empty().append(template)
      $popover.addClass("is-visible")

      // clear popover timer, set at top of Cart object
      clearTimeout(instance.popoverTimer)

      // set new instace of popoverTimer
      instance.popoverTimer = setTimeout(function () {
        Cart.popover.hide($popover)
      }, 5000)
    },
    hide: function (el) {
      el.removeClass("is-visible")
      setTimeout(function () {
        el.empty()
      }, 300)
    },
    getTruncatedTitle: function (title) {
      if (title.length > 20) {
        title = title.substring(0, 20) + " ..."
      }

      return title
    },
  },
  getCart: function (callback) {
    $.getJSON("/cart.js", function (cart, textStatus) {
      if (typeof callback === "function") {
        callback(cart)
      } else {
        ShopifyAPI.onCartUpdate(cart)
      }
    })
  },
  buildCart: function (cart) {
    var self = this,
      $cart = $("#Cart"),
      $body = $("body"),
      acceptanceChecked = !!$cart.attr("data-acceptance-checked") || false

    // Start with a fresh cart div
    $cart.empty()

    // Append close icon if page is not cart template only
    if (!$body.hasClass("template-cart")) {
      $cart.append(
        '<div class="js-cartToggle js-cartToggle-close cart-close">' +
          window.theme.icons.close +
          "</div>"
      )
    }

    // Show empty cart
    if (cart.item_count === 0) {
      $cart.append(
        '<div class="cart-title cart-title--empty">\
							<h2>' +
          window.theme.translations.cart_title +
          "</h2>\
							<p>" +
          window.theme.translations.cart_empty +
          '</p>\
							<a tabindex="-1" class="js-continueShopping js-continueShopping--empty js-go-back button">' +
          window.theme.translations.continue_shopping +
          "</a>\
						</div>"
      )

      // Update cart total
      self.updateCartTotal()
      Site.setCartClosePosition()

      return
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html()

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      var itemQty = cartItem.quantity,
        itemVariantId = cartItem.variant_id,
        discountsArray = cartItem.discounts,
        discounts = "",
        productPrice = "",
        productTotalPrice = "",
        unitPrice = ""

      // Get line price value
      if (cartItem.original_price > cartItem.final_price) {
        productPrice +=
          "<s>" +
          slate.Currency.formatMoney(
            cartItem.original_price,
            window.moneyFormat
          ) +
          "</s> "
      }
      productPrice +=
        "<span>" +
        slate.Currency.formatMoney(cartItem.final_price, window.moneyFormat) +
        "</span>"

      // Get total line price value
      if (cartItem.original_line_price > cartItem.final_line_price) {
        productTotalPrice +=
          "<s>" +
          slate.Currency.formatMoney(
            cartItem.original_line_price,
            window.moneyFormat
          ) +
          "</s> "
      }
      productTotalPrice += slate.Currency.formatMoney(
        cartItem.final_line_price,
        window.moneyFormat
      )

      // Get discounts
      if (discountsArray.length) {
        discounts += '<div class="cart-product__discounts">'
        for (var j = 0; j < discountsArray.length; j++) {
          discounts +=
            "<p>" +
            discountsArray[j].title +
            " (-" +
            slate.Currency.formatMoney(
              discountsArray[j].amount,
              window.moneyFormat
            ) +
            ")</p>"
        }
        discounts += "</div>"
      }

      // Unit price
      if (cartItem.unit_price_measurement) {
        unitPrice =
          slate.Currency.formatMoney(cartItem.unit_price, window.moneyFormat) +
          " "
        unitPrice +=
          '<span aria-hidden="true">/</span><span class="visually-hidden">' +
          window.theme.translations.unit_price_separator +
          "</span>&nbsp;"
        if (cartItem.unit_price_measurement.reference_value != 1) {
          unitPrice += cartItem.unit_price_measurement.reference_value
        }
        unitPrice += cartItem.unit_price_measurement.reference_unit
      }

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */

      if (cartItem.image != null) {
        var prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, "_300x$1")
          .replace("http:", "")
      } else {
        var prodImg =
          "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif"
      }

      var prodName = cartItem.product_title,
        prodVariation = cartItem.variant_title

      if (prodVariation == "Default Title") {
        prodVariation = false
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        url: cartItem.url,
        img: prodImg,
        name: prodName,
        variation: prodVariation,
        itemQty: itemQty,
        itemVariantId: itemVariantId,
        properties: cartItem.properties,
        price: cartItem.price,
        priceFormatted: productPrice,
        unitPrice: unitPrice,
        linePriceFormatted: productTotalPrice,
        discounts: discounts,
        vendor: cartItem.vendor,
        iconPlus: window.theme.icons.plus,
        iconMinus: window.theme.icons.minus,
      }

      items.push(item)
    })

    // Update cart totals
    var totalDiscounts = ""
    var cartDiscounts = cart.cart_level_discount_applications

    if (cartDiscounts.length) {
      totalDiscounts += '<p class="cart-discounts">'
      for (var j = 0; j < cartDiscounts.length; j++) {
        totalDiscounts += "<span>" + cartDiscounts[j].title + ":</span>"
        totalDiscounts +=
          "<span>-" +
          slate.Currency.formatMoney(
            cartDiscounts[j].total_allocated_amount,
            window.moneyFormat
          ) +
          "</span>"
      }
      totalDiscounts += "</p>"
    }

    // Gather all cart data and add to DOM
    data = {
      item_count: cart.item_count,
      items: items,
      note: cart.note,
      totalDiscounts: totalDiscounts,
      totalPrice: slate.Currency.formatMoney(
        cart.total_price,
        window.moneyFormat
      ),
      acceptanceChecked: acceptanceChecked,
    }

    var template = Sqrl.render(source, data)
    // update cart slide-out with new cart
    $cart.append(template)

    // Update cart total
    Cart.updateCartTotal()
    Cart.initTermsAcceptance()
    Site.setCartClosePosition()

    /**
     * Re-init the ajax cart buttons.
     * These are added to the handlebars template, but this
     * js needs to fire to show them after the new
     * cart is built and inserted.
     * @see https://help.shopify.com/themes/customization/cart/add-more-checkout-buttons-to-cart-page
     */
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize()
    }

    /**********************************************************/
    /* Dewey's custom -                                       */
    /* need to initialize GiftShip after cart udpate          */
    /**********************************************************/
    if (typeof Gs !== "undefined") {
      Gs.initialize(Gs.$, !1)
    }
  },
  /*
   * Form Counter
   */
  counter: function () {
    var self = this,
      $cart = $("#Cart"),
      namespace = ".cart"

    $cart
      // Reset all event listeners here
      .off(namespace)
      .on("change" + namespace, ".inputCounter", function () {
        var el = $(this),
          value = $(this).val()

        self.inputCounter(el, value)
      })
      .on("click" + namespace, ".inputCounter__btn--down", function (e) {
        var el = $(this),
          $input = el.siblings(".inputCounter"),
          value = parseInt($input.val()) - 1

        self.inputCounter(el, value)
      })
      .on("click" + namespace, ".inputCounter__btn--up", function (e) {
        var el = $(this),
          $input = el.siblings(".inputCounter"),
          value = parseInt($input.val()) + 1

        self.inputCounter(el, value)
      })
      /* Remove line item on x click */
      .on("click" + namespace, ".cart-product__remove", function () {
        var el = $(this)

        self.inputCounter(el, 0)
      })
  },

  // Product/Quick View Product Submit Form
  inputCounter: function (el, value) {
    var self = this,
      $input = el.closest(".line-item").find(".inputCounter")

    // Set quantity to 0 and remove the item
    if (value == 0) {
      $input.closest(".line-item").fadeOut(function () {
        $(this).remove()
      })

      // Prevent a negative quantity
    } else if (value < 0) {
      value = 0
    }

    var qty = value
    var line = parseInt($input.closest(".line-item").index() + 1)

    $.ajax({
      type: "post",
      url: "/cart/change.js",
      dataType: "json",
      data: {
        quantity: qty,
        line: line,
      },
      success: function (cart) {
        Cart.buildCart(cart)
      },
    })

    // remove line item if the quantity is 0
    if (qty == 0) {
      $(this)
        .closest(".line-item")
        .fadeOut(function () {
          $(this).remove()
          self.updateCartTotal()
        })
    }
  },
  updateCartTotal: function () {
    $.getJSON("/cart.js", function (cart) {
      $("#CartToggleItemCount").html(cart.item_count)
      cart.item_count
        ? $(".js-cartToggle").removeClass("cartToggle--empty")
        : $(".js-cartToggle").addClass("cartToggle--empty")
    })
  },
  initTermsAcceptance: function () {
    var namespace = ".cart"
    var selectors = {
      cartAcceptance: "[data-cart-acceptance]",
      cartButtons: "[data-cart-buttons]",
      cartButtonsFieldset: "[data-cart-buttons-fieldset]",
      cartContainer: ".cart-container",
      cartFormError: "[data-cart-error]",
    }

    // Terms and conditions checkbox listener
    if ($(selectors.cartAcceptance).length) {
      var cartFormErrorElement =
          '<div class="errors" data-cart-error>' +
          window.theme.translations.cart_acceptance_error +
          "</div>",
        termsAccepted = $(selectors.cartAcceptance).is(":checked")

      var formSubmitFunction = function (e) {
        var termsAccepted = $(selectors.cartAcceptance).is(":checked")

        // Disable form submit if terms and conditions are not accepted
        if (!termsAccepted) {
          e.preventDefault()
          if ($(selectors.cartFormError).length) return

          $(selectors.cartButtonsFieldset).attr("disabled", true)
          $(selectors.cartButtons).before(cartFormErrorElement)
          $(selectors.cartFormError).slideDown()
          $(selectors.cartContainer).removeAttr("data-acceptance-checked")
        } else {
          // Enable buttons
          $(selectors.cartFormError)
            .stop()
            .slideUp("fast", function () {
              $(this).remove()
            })
          $(selectors.cartButtonsFieldset).removeAttr("disabled")
          $(selectors.cartContainer).attr("data-acceptance-checked", "checked")
        }
      }

      if (!termsAccepted) {
        // Disable buttons
        $(selectors.cartButtonsFieldset).attr("disabled", true)
      }

      $(selectors.cartContainer)
        .on("click" + namespace, selectors.cartButtons, formSubmitFunction)
        .on("submit" + namespace, selectors.cartForm, formSubmitFunction)
        .on(
          "submit" + namespace,
          selectors.cartFormDynamicCheckout,
          formSubmitFunction
        )
        .on("change" + namespace, selectors.cartAcceptance, formSubmitFunction)
    }
  },
}

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function (name, url) {
    if (!url) url = window.location.href
    name = name.replace(/[[\]]/g, "\\$&")
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ""
    return decodeURIComponent(results[2].replace(/\+/g, " "))
  },

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i]
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1)
        break
      }
    }

    return array
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1
    var length = array == null ? 0 : array.length
    var resIndex = 0
    var result = []

    while (++index < length) {
      var value = array[index]
      if (value) {
        result[resIndex++] = value
      }
    }
    return result
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39,
  },
}

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = "js-focus-hidden"

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback)

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex")
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash))
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash))
      }.bind(this)
    )
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventsName = {
      focusin: options.namespace ? "focusin." + options.namespace : "focusin",
      focusout: options.namespace
        ? "focusout." + options.namespace
        : "focusout",
      keydown: options.namespace
        ? "keydown." + options.namespace
        : "keydown.handleFocus",
    }

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(":visible")
    )
    var firstFocusable = $focusableElements[0]
    var lastFocusable = $focusableElements[$focusableElements.length - 1]

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault()
        firstFocusable.focus()
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault()
        lastFocusable.focus()
      }
    }

    options.$container.attr("tabindex", "-1")
    options.$elementToFocus.focus()

    $(document).off("focusin")

    $(document).on(eventsName.focusout, function () {
      $(document).off(eventsName.keydown)
    })

    $(document).on(eventsName.focusin, function (evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return

      $(document).on(eventsName.keydown, function (evt) {
        _manageFocus(evt)
      })
    })
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin"

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex")
    }

    $(document).off(eventName)
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function (options) {
    var body = document.querySelector("body")

    var idSelectors = {
      newWindow: "a11y-new-window-message",
      external: "a11y-external-message",
      newWindowExternal: "a11y-new-window-external-message",
    }

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $("a[href]:not([aria-describedby])")
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== "object") {
        customMessages = {}
      }

      var messages = $.extend(
        {
          newWindow: "Opens in a new window.",
          external: "Opens external website.",
          newWindowExternal: "Opens external website in a new window.",
        },
        customMessages
      )

      var container = document.createElement("ul")
      var htmlMessages = ""

      for (var message in messages) {
        htmlMessages +=
          "<li id=" + idSelectors[message] + ">" + messages[message] + "</li>"
      }

      container.setAttribute("hidden", true)
      container.innerHTML = htmlMessages

      body.appendChild(container)
    }

    function _externalSite($link) {
      var hostname = window.location.hostname

      return $link[0].hostname !== hostname
    }

    $.each(options.$links, function () {
      var $link = $(this)
      var target = $link.attr("target")
      var rel = $link.attr("rel")
      var isExternal = _externalSite($link)
      var isTargetBlank = target === "_blank"

      if (isExternal) {
        $link.attr("aria-describedby", idSelectors.external)
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf("noopener") === -1) {
          $link.attr("rel", function (i, val) {
            var relValue = val === undefined ? "" : val + " "
            return relValue + "noopener"
          })
        }
        $link.attr("aria-describedby", idSelectors.newWindow)
      }
      if (isExternal && isTargetBlank) {
        $link.attr("aria-describedby", idSelectors.newWindowExternal)
      }
    })

    generateHTML(options.messages)
  },
}

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container
    this.product = options.product
    this.singleOptionSelector = options.singleOptionSelector
    this.originalSelectorId = options.originalSelectorId
    this.enableHistoryState = options.enableHistoryState
    this.currentVariant = this._getVariantFromOptions()

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    )
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element)
          var type = $element.attr("type")
          var currentOption = {}

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val()
              currentOption.index = $element.data("index")

              return currentOption
            } else {
              return false
            }
          } else {
            currentOption.value = $element.val()
            currentOption.index = $element.data("index")

            return currentOption
          }
        }
      )

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions)

      return currentOptions
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions()
      var variants = this.product.variants
      var found = false

      variants.forEach(function (variant) {
        var satisfied = true

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index]
          }
        })

        if (satisfied) {
          found = variant
        }
      })

      return found || null
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions()

      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      })

      if (!variant) {
        return
      }

      this._updateMasterSelect(variant)
      this._updateImages(variant)
      this._updatePrice(variant)
      this._updateUnits(variant)
      this.currentVariant = variant

      if (this.enableHistoryState) {
        this._updateHistoryState(variant)
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {}
      var currentVariantImage = this.currentVariant.featured_image || {}

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      })
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      })
    },

    /**
     * Trigger event when variant price per unit changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantUnitChange
     */
    _updateUnits: function (variant) {
      this.$container.trigger({
        type: "variantUnitChange",
        variant: variant,
      })
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id
      window.history.replaceState({ path: newurl }, "", newurl)
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id
    },
  })

  return Variants
})()
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

slate.Currency = (function () {
  var moneyFormat = "${{amount}}" // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "")
    }
    var value = ""
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
    var formatString = format || moneyFormat

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ","
      decimal = decimal || "."

      if (isNaN(number) || number === null) {
        return 0
      }

      number = (number / 100.0).toFixed(precision)

      var parts = number.split(".")
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      )
      var centsAmount = parts[1] ? decimal + parts[1] : ""

      return dollarsAmount + centsAmount
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2)
        break
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0)
        break
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",")
        break
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",")
        break
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ")
        break
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'")
        break
    }

    return formatString.replace(placeholderRegex, value)
  }

  return {
    formatMoney: formatMoney,
  }
})()

var Disclosure = (function () {
  var selectors = {
    disclosureList: "[data-disclosure-list]",
    disclosureToggle: "[data-disclosure-toggle]",
    disclosureInput: "[data-disclosure-input]",
    disclosureOptions: "[data-disclosure-option]",
  }

  var classes = {
    listVisible: "disclosure-list--visible",
  }

  function Disclosure($disclosure) {
    this.$container = $disclosure
    this.cache = {}
    this._cacheSelectors()
    this._connectOptions()
    this._connectToggle()
    this._onFocusOut()
  }

  Disclosure.prototype = $.extend({}, Disclosure.prototype, {
    _cacheSelectors: function () {
      this.cache = {
        $disclosureList: this.$container.find(selectors.disclosureList),
        $disclosureToggle: this.$container.find(selectors.disclosureToggle),
        $disclosureInput: this.$container.find(selectors.disclosureInput),
        $disclosureOptions: this.$container.find(selectors.disclosureOptions),
      }
    },

    _connectToggle: function () {
      this.cache.$disclosureToggle.on(
        "click",
        function (evt) {
          var ariaExpanded =
            $(evt.currentTarget).attr("aria-expanded") === "true"
          $(evt.currentTarget).attr("aria-expanded", !ariaExpanded)

          this.cache.$disclosureList.toggleClass(classes.listVisible)
          evt.preventDefault()
        }.bind(this)
      )
    },

    _connectOptions: function () {
      this.cache.$disclosureOptions.on(
        "click",
        function (evt) {
          this._submitForm($(evt.currentTarget).data("value"))
          evt.preventDefault()
        }.bind(this)
      )
    },

    _onFocusOut: function () {
      this.cache.$disclosureToggle.on(
        "focusout",
        function (evt) {
          var disclosureLostFocus =
            this.$container.has(evt.relatedTarget).length === 0

          if (disclosureLostFocus) {
            this._hideList()
          }
        }.bind(this)
      )

      this.cache.$disclosureList.on(
        "focusout",
        function (evt) {
          var childInFocus =
            $(evt.currentTarget).has(evt.relatedTarget).length > 0
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          )

          if (isVisible && !childInFocus) {
            this._hideList()
          }
        }.bind(this)
      )

      this.$container.on(
        "keyup",
        function (evt) {
          if (evt.which !== slate.utils.keyboardKeys.ESCAPE) return
          this._hideList()
          this.cache.$disclosureToggle.focus()
        }.bind(this)
      )

      this.bodyOnClick = function (evt) {
        var isOption = this.$container.has(evt.target).length > 0
        var isVisible = this.cache.$disclosureList.hasClass(classes.listVisible)

        if (isVisible && !isOption) {
          this._hideList()
        }
      }.bind(this)

      $("body").on("click", this.bodyOnClick)
    },

    _submitForm: function (value) {
      this.cache.$disclosureInput.val(value)
      this.$container.parents("form").submit()
    },

    _hideList: function () {
      this.cache.$disclosureList.removeClass(classes.listVisible)
      this.cache.$disclosureToggle.attr("aria-expanded", false)
    },

    unload: function () {
      $("body").off("click", this.bodyOnClick)
      this.cache.$disclosureOptions.off()
      this.cache.$disclosureToggle.off()
      this.cache.$disclosureList.off()
      this.$container.off()
    },
  })

  return Disclosure
})()

theme.StoreAvailability = (function () {
  var selectors = {
    body: "body",
    storeAvailabilityModal: "[data-store-availability-modal]",
    storeAvailabilityModalOpen: "[data-store-availability-modal-open]",
    storeAvailabilityModalProductTitle:
      "[data-store-availability-modal-product-title]",
    storeAvailabilityUnitSystem: "[data-unit-system]",
    storeAvailabilityLocationDistance: "[data-distance]",
    storeAvailabilityDistanceUnit: "[data-distance-unit]",
  }

  var classes = {
    hidden: "visually-hidden",
  }

  function StoreAvailability(container) {
    this.container = container
  }

  StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
    updateContent: function (variantId, productTitle) {
      var options = {
        maximumAge: 3600000, // 1 hour
        timeout: 5000,
      }
      var self = this
      // Not all browsers have geolocation API
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          // success callback
          function (position) {
            self._useGeolocation(position, variantId, productTitle)
          },
          // failure callback
          function () {
            self._fetchStoreAvailabilities(variantId, productTitle)
          },
          options
        )
      } else {
        this._fetchStoreAvailabilities(variantId, productTitle)
      }
    },

    clearContent: function () {
      this.container.innerHTML = ""
    },

    _initModal: function () {
      return new theme.Modals(
        "StoreAvailabilityModal",
        "store-availability-modal",
        {
          close: ".js-modal-close-store-availability-modal",
          closeModalOnClick: true,
          openClass: "store-availabilities-modal--active",
          scrollIntoView: true,
        }
      )
    },

    _useGeolocation: function (position, variantId, productTitle) {
      var coordinates = position.coords
      var latitude = coordinates.latitude
      var longitude = coordinates.longitude
      if (theme.Helpers.cookiesEnabled()) {
        var latitudeFromCookie = theme.Helpers.getCookie("latitude")
        var longitudeFromCookie = theme.Helpers.getCookie("longitude")
        if (
          latitudeFromCookie &&
          longitudeFromCookie &&
          parseFloat(latitudeFromCookie) === latitude &&
          parseFloat(longitudeFromCookie) === longitude
        ) {
          this._fetchStoreAvailabilities(
            variantId,
            productTitle,
            latitude,
            longitude
          )
        } else {
          var oneHour = 1 / 24
          theme.Helpers.setCookie("latitude", latitude, oneHour)
          theme.Helpers.setCookie("longitude", longitude, oneHour)
          this._setBuyerLocation(latitude, longitude, variantId, productTitle)
        }
      } else {
        this._fetchStoreAvailabilities(variantId, productTitle)
      }
    },

    _setBuyerLocation: function (latitude, longitude, variantId, productTitle) {
      var self = this
      fetch("/localization.json", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ latitude: latitude, longitude: longitude }),
      }).then(function () {
        self._fetchStoreAvailabilities(
          variantId,
          productTitle,
          latitude,
          longitude
        )
      })
    },

    _fetchStoreAvailabilities: function (
      variantId,
      productTitle,
      latitude,
      longitude
    ) {
      var variantSectionUrl =
        "/variants/" + variantId + "/?section_id=store-availability"
      this.clearContent()
      var self = this
      fetch(variantSectionUrl)
        .then(function (response) {
          return response.text()
        })
        .then(function (storeAvailabilityHTML) {
          if (storeAvailabilityHTML.trim() === "") {
            return
          }

          var body = document.querySelector(selectors.body)
          var storeAvailabilityModal = body.querySelector(
            selectors.storeAvailabilityModal
          )

          if (storeAvailabilityModal) {
            storeAvailabilityModal.remove()
          }

          self.container.innerHTML = storeAvailabilityHTML
          self.container.innerHTML = self.container.firstElementChild.innerHTML

          var storeAvailabilityModalOpen = self.container.querySelector(
            selectors.storeAvailabilityModalOpen
          )
          // Only create modal if open modal element exists
          if (!storeAvailabilityModalOpen) {
            return
          }

          self.modal = self._initModal()
          self._updateProductTitle(productTitle)
          if (latitude && longitude) {
            self._updateLocationDistances(latitude, longitude)
          } else {
            self._hideDistanceUnits()
          }

          var storeAvailabilityModal = self.container.querySelector(
            selectors.storeAvailabilityModal
          )

          if (storeAvailabilityModal) {
            body.appendChild(storeAvailabilityModal)
          }
        })
    },

    _updateProductTitle: function (productTitle) {
      var storeAvailabilityModalProductTitle = this.container.querySelector(
        selectors.storeAvailabilityModalProductTitle
      )
      storeAvailabilityModalProductTitle.textContent = productTitle
    },

    // Haversine Distance
    // The haversine formula is an equation giving great-circle distances between
    // two points on a sphere from their longitudes and latitudes
    _calculateDistance: function (
      latitude1,
      longitude1,
      latitude2,
      longitude2,
      unitSystem
    ) {
      var dtor = Math.PI / 180
      var radius = unitSystem === "metric" ? 6378.14 : 3959

      var rlat1 = latitude1 * dtor
      var rlong1 = longitude1 * dtor
      var rlat2 = latitude2 * dtor
      var rlong2 = longitude2 * dtor

      var dlon = rlong1 - rlong2
      var dlat = rlat1 - rlat2

      var a =
        Math.pow(Math.sin(dlat / 2), 2) +
        Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(dlon / 2), 2)
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      return radius * c
    },

    _updateLocationDistances: function (latitude, longitude) {
      var countryCode = document.querySelector(
        selectors.storeAvailabilityUnitSystem
      )
      var unitSystem = countryCode.dataset.unitSystem
      var allDistances = document.querySelectorAll(
        selectors.storeAvailabilityLocationDistance
      )
      var allDistancesArray = Array.from(allDistances)
      var self = this
      allDistancesArray.forEach(function (locationDistance) {
        var distance = self
          ._calculateDistance(
            latitude,
            longitude,
            parseFloat(locationDistance.dataset.latitude),
            parseFloat(locationDistance.dataset.longitude),
            unitSystem
          )
          .toFixed(1)
        locationDistance.innerHTML = distance
      })
    },

    _hideDistanceUnits: function () {
      var distanceUnits = document.querySelectorAll(
        selectors.storeAvailabilityDistanceUnit
      )

      if (!distanceUnits) {
        return
      }

      var distanceUnitsArray = Array.from(distanceUnits)
      distanceUnitsArray.forEach(function (distanceUnit) {
        distanceUnit.classList.add(classes.hidden)
      })
    },
  })

  return StoreAvailability
})()

// theme.Modals = (function () {
//   function Modal(id, name, options) {
//     var defaults = {
//       close: ".js-modal-close",
//       open: ".js-modal-open-" + name,
//       openClass: "modal--is-active",
//       openBodyClass: "modal--is-visible",
//       closeModalOnClick: false,
//       scrollIntoView: false,
//     }

//     this.modal = document.getElementById(id)

//     if (!this.modal) return false

//     this.nodes = {
//       parents: [document.querySelector("html"), document.body],
//     }

//     this.config = Object.assign(defaults, options)

//     this.modalIsOpen = false

//     this.focusOnOpen = this.config.focusOnOpen
//       ? document.getElementById(this.config.focusOnOpen)
//       : this.modal

//     this.openElement = document.querySelector(this.config.open)
//     this.init()
//   }

//   Modal.prototype.init = function () {
//     this.openElement.addEventListener("click", this.open.bind(this))

//     this.modal
//       .querySelector(this.config.close)
//       .addEventListener("click", this.closeModal.bind(this))
//   }

//   Modal.prototype.open = function (evt) {
//     var self = this

//     // Keep track if modal was opened from a click, or called by another function
//     var externalCall = false

//     if (this.modalIsOpen) return

//     // Prevent following href if link is clicked
//     if (evt) {
//       evt.preventDefault()
//     } else {
//       externalCall = true
//     }

//     // Without this, the modal opens, the click event bubbles up
//     // which closes the modal.
//     if (evt && evt.stopPropagation) {
//       evt.stopPropagation()
//     }

//     if (this.modalIsOpen && !externalCall) {
//       this.closeModal()
//     }

//     this.modal.classList.add(this.config.openClass)

//     this.nodes.parents.forEach(function (node) {
//       node.classList.add(self.config.openBodyClass)
//     })

//     this.modalIsOpen = true

//     var scrollableElement = document.querySelector(".store-availabilities-list")
//     scrollLock.disablePageScroll(scrollableElement)

//     slate.a11y.trapFocus({
//       $container: $(this.modal),
//       $elementToFocus: $(this.focusOnOpen),
//     })

//     if (this.config.scrollIntoView) {
//       this.scrollIntoView()
//     }

//     this.bindEvents()
//   }

//   Modal.prototype.closeModal = function () {
//     if (!this.modalIsOpen) return

//     document.activeElement.blur()

//     this.modal.classList.remove(this.config.openClass)

//     var self = this
//     var scrollableElement = document.querySelector(".store-availabilities-list")
//     scrollLock.enablePageScroll(scrollableElement)

//     this.nodes.parents.forEach(function (node) {
//       node.classList.remove(self.config.openBodyClass)
//     })

//     this.modalIsOpen = false

//     slate.a11y.removeTrapFocus({
//       $container: $(this.modal),
//     })

//     this.openElement.focus()

//     this.unbindEvents()
//   }

//   Modal.prototype.bindEvents = function () {
//     this.keyupHandler = this.keyupHandler.bind(this)
//     this.clickHandler = this.clickHandler.bind(this)
//     document.body.addEventListener("keyup", this.keyupHandler)
//     document.body.addEventListener("click", this.clickHandler)
//   }

//   Modal.prototype.unbindEvents = function () {
//     document.body.removeEventListener("keyup", this.keyupHandler)
//     document.body.removeEventListener("click", this.clickHandler)
//   }

//   Modal.prototype.keyupHandler = function (event) {
//     if (event.keyCode === 27) {
//       this.closeModal()
//     }
//   }

//   Modal.prototype.clickHandler = function (event) {
//     if (this.config.closeModalOnClick && !this.modal.contains(event.target)) {
//       this.closeModal()
//     }
//   }

//   Modal.prototype.scrollIntoView = function () {
//     this.focusOnOpen.scrollIntoView({
//       behavior: "smooth",
//     })
//   }

//   return Modal
// })()

// theme.Helpers = (function () {
//   function cookiesEnabled() {
//     var cookieEnabled = navigator.cookieEnabled

//     if (!cookieEnabled) {
//       document.cookie = "testcookie"
//       cookieEnabled = document.cookie.indexOf("testcookie") !== -1
//     }

//     return cookieEnabled
//   }

//   function setCookie(name, value, days) {
//     var expires = ""
//     if (days) {
//       var date = new Date()
//       date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
//       expires = "; expires=" + date.toUTCString()
//     }
//     document.cookie = name + "=" + (value || "") + expires + "; path=/"
//   }

//   function getCookie(name) {
//     var cookie = document.cookie.split("; ").find(function (row) {
//       return row.startsWith(name)
//     })

//     if (cookie) {
//       return cookie.split("=")[1]
//     } else {
//       return null
//     }
//   }

//   return {
//     cookiesEnabled: cookiesEnabled,
//     setCookie: setCookie,
//     getCookie: getCookie,
//   }
// })()
